import { HeartHandshake, Building2 } from "lucide-react";

const NGO_PARTNERS = [
  "Education Mission",
  "Rural Health Trust",
  "Green Earth Initiative",
  "Women's Collective",
  "Skill Development Trust",
  "Child Welfare Society",
  "Clean Water Project",
  "Livelihood Mission",
  "Tribal Welfare Trust",
  "Nutrition Foundation",
];

const CORPORATE_FUNDERS = [
  "IT & Technology CSR",
  "Banking & Finance CSR",
  "Energy PSU CSR",
  "FMCG Foundation",
  "Automotive CSR",
  "Telecom Foundation",
  "Pharma CSR",
  "Infrastructure CSR",
  "Hospitality CSR",
  "Textiles CSR",
];

function Row({ items, icon: Icon, reverse, testId, chipClass }) {
  const doubled = [...items, ...items];
  return (
    <div className="marquee-group relative overflow-hidden py-3" data-testid={testId}>
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#FBFBF9] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#FBFBF9] to-transparent" />
      <div className={`flex w-max gap-4 ${reverse ? "animate-marquee-reverse" : "animate-marquee"}`}>
        {doubled.map((name, i) => (
          <span
            key={`${name}-${i}`}
            className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full border px-5 py-2.5 text-sm font-semibold ${chipClass}`}
          >
            <Icon className="h-4 w-4" />
            {name}
          </span>
        ))}
      </div>
    </div>
  );
}

export default function ClientMarquee() {
  return (
    <section className="border-y border-[#E6E9E6] bg-[#FBFBF9] py-12">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <p
          data-testid="marquee-section-heading"
          className="text-center text-xs font-semibold uppercase tracking-[0.22em] text-slate-500"
        >
          Trusted by NGOs across India · Connected to India's leading corporate CSR desks
        </p>
      </div>
      <div className="mt-8 space-y-2">
        <Row
          items={NGO_PARTNERS}
          icon={HeartHandshake}
          testId="marquee-ngo-partners"
          chipClass="border-[#3D63B8]/30 bg-[#EAF1FC] text-[#0E2A6B]"
        />
        <Row
          items={CORPORATE_FUNDERS}
          icon={Building2}
          reverse
          testId="marquee-corporate-donors"
          chipClass="border-[#F2C391]/50 bg-[#FDF1E3] text-[#C96F1B]"
        />
      </div>
      <p className="mt-6 text-center text-xs text-slate-400">
        Representative network of associated partners and CSR desks engaged through past mandates
      </p>
    </section>
  );
}
